import { BarberDashboardOverview } from "@/services/barberDashboard/types";
import { IconChevronLeft, IconEye, IconEyeOff } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { compactRialText } from "./format";
import classes from "./home.module.scss";

const HIDDEN = "••••••";

type Props = {
  report?: BarberDashboardOverview;
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
  hidden: boolean;
  onToggleHidden: () => void;
  // The salon's owner: nothing is owed to them, so the month's work takes that place.
  isOwner?: boolean;
};

// The two numbers a stylist checks, hideable for when the phone is in a client's view; the rest is in «گزارش من».
export default function MyEarnings({ report, isLoading, isError, onRetry, hidden, onToggleHidden, isOwner }: Props) {
  const amount = (rial?: number | null) => (hidden ? HIDDEN : compactRialText(rial));
  const second = isOwner
    ? { label: "کارکرد این ماه", value: report?.headline?.monthEarnings?.value }
    : { label: "طلب از سالن", value: report?.earnings?.outstanding };
  return (
    <section className={classes.section} aria-labelledby="home-earnings-title">
      <div className={classes.sectionHead}>
        <h2 id="home-earnings-title" className={classes.sectionTitle}>
          کارکرد من
        </h2>
        <span className={classes.sectionActions}>
          <button
            type="button"
            className={classes.iconButton}
            aria-pressed={hidden}
            aria-label={hidden ? "نمایش مبالغ" : "پنهان کردن مبالغ"}
            onClick={onToggleHidden}
          >
            {hidden ? <IconEyeOff size={20} stroke={1.7} aria-hidden /> : <IconEye size={20} stroke={1.7} aria-hidden />}
          </button>
          <Link to="/dashboard/barber-overview" className={classes.textLink}>
            گزارش من
            <IconChevronLeft size={16} stroke={1.7} aria-hidden />
          </Link>
        </span>
      </div>
      <div className={classes.card} aria-busy={isLoading || undefined}>
        {isError ? (
          <div className={classes.empty}>
            <span className={classes.emptyTitle}>کارکرد دریافت نشد</span>
            <button type="button" className={classes.softAction} onClick={onRetry}>
              تلاش دوباره
            </button>
          </div>
        ) : (
          <div className={classes.earnings}>
            <div className={classes.earningsItem}>
              <span>کارکرد امروز</span>
              {isLoading ? (
                <span className={classes.shimmerLight} style={{ width: "70%", height: 18 }} />
              ) : (
                <strong>{amount(report?.headline?.todayEarnings?.value)}</strong>
              )}
            </div>
            <div className={classes.earningsItem}>
              <span>{second.label}</span>
              {isLoading ? (
                <span className={classes.shimmerLight} style={{ width: "70%", height: 18 }} />
              ) : (
                <strong>{amount(second.value)}</strong>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
